<app-header *ngIf="_login || !isLanding"></app-header>
<app-side-menu class="nav" [isVisibleButton]="burgerMenuVisible" [isLoggedIn]="_login"></app-side-menu>
<!-- <div class="content">
    <router-outlet ></router-outlet>
</div> -->
<app-footer class="footer"></app-footer>


